import OccupancyCountsAttribute from './OccupancyCountsAttribute'
import SegmentImagesAttribute from './SegmentImagesAttribute'
import EventsSetup from './events/PluginSetup'

export default {
  install( molten ) {
    molten.addPlugin( 'Attribute', OccupancyCountsAttribute )
    molten.addPlugin( 'Attribute', SegmentImagesAttribute )
    EventsSetup.install( molten )
  }
}
